export default "__VITE_PUBLIC_ASSET__e465ac0a__"